import { useLocalizedHref } from "@/libraries/web-framework/index.ts";

import { Link } from "../../../../libraries/design/components/link/src/link.tsx";

import type { LinkProps } from "../../../../libraries/design/components/link/src/link.tsx";

export const UniformLink = (props: LinkProps) => {
    const localizedHref = useLocalizedHref(props.href);
    return <Link {...props} href={localizedHref} />;
};
